/**
 * Foremark 主题交互 — 主题切换、变体联动、Ajax 加购、购物车、Toast
 */
(function () {
  'use strict';

  var theme = window.ForemarkTheme || {};
  var t = theme.translations || {};

  // ── 主题模式（Dark / Light）────────────────────────────────────
  function initTheme() {
    var forced = new URLSearchParams(location.search).get('theme');
    if (forced === 'light' || forced === 'dark') {
      document.documentElement.setAttribute('data-theme', forced);
      localStorage.setItem('foremark-theme', forced);
    } else {
      var stored = localStorage.getItem('foremark-theme');
      var prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      var initial = stored || (prefersDark ? 'dark' : 'light');
      document.documentElement.setAttribute('data-theme', initial);
    }

    var toggle = document.getElementById('theme-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-theme') || 'dark';
        var next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        localStorage.setItem('foremark-theme', next);
      });
    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
      if (!localStorage.getItem('foremark-theme')) {
        document.documentElement.setAttribute('data-theme', e.matches ? 'dark' : 'light');
      }
    });
  }

  function formatMoney(cents) {
    return (Number(cents) / 100).toLocaleString(theme.locale || 'ja-JP', {
      style: 'currency',
      currency: theme.currency || 'JPY'
    });
  }

  // ── 购物车角标更新 ─────────────────────────────────────────────
  function updateCartBadge(count) {
    var badge = document.getElementById('cart-badge');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.removeAttribute('hidden');
    } else {
      badge.textContent = '0';
      badge.setAttribute('hidden', '');
    }
  }

  function fetchCart() {
    var cartUrl = (theme.routes && theme.routes.cart) ? theme.routes.cart + '.js' : '/cart.js';
    return fetch(cartUrl)
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function fetchCartCount() {
    return fetchCart().then(function (cart) {
      if (cart) updateCartBadge(cart.item_count);
      return cart;
    });
  }

  function showToast(message, options) {
    options = options || {};
    var existing = document.getElementById('fm-cart-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'fm-cart-toast';
    toast.className = 'fm-cart-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = '<p class="fm-cart-toast-msg">' + message + '</p>';

    if (options.linkUrl) {
      var link = document.createElement('a');
      link.href = options.linkUrl;
      link.className = 'fm-cart-toast-link';
      link.textContent = options.linkText || 'View cart';
      toast.appendChild(link);
    }

    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });

    var duration = options.duration || 5000;
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 300);
    }, duration);
  }

  /**
   * Ajax 加购 — 单条 line item
   */
  function addLineItem(variantId, quantity, properties) {
    var cartAddUrl = (theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    var payload = {
      id: Number(variantId),
      quantity: quantity,
      properties: properties || {}
    };

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    });
  }

  function changeLineItem(key, quantity) {
    var cartChangeUrl = (theme.routes && theme.routes.cartChange) || '/cart/change.js';
    return fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    });
  }

  /**
   * 通用加购 — 主商品 + 可选双面刻印附加商品
   */
  function addToCart(variantId, properties, extras) {
    extras = extras || {};
    var qty = extras.quantity || 1;
    var includeAddon = extras.includeAddon || false;
    var addonVariantId = extras.addonVariantId || null;
    var addonNote = (t.product && t.product.addon_note)
      ? t.product.addon_note
      : 'Double-sided engraving addon';

    return addLineItem(variantId, qty, properties).then(function (result) {
      if (includeAddon && addonVariantId) {
        var addonProps = Object.assign({}, properties || {}, { Note: addonNote });
        return addLineItem(addonVariantId, qty, addonProps).then(function () { return result; });
      }
      return result;
    }).then(function (result) {
      return fetchCartCount().then(function () { return result; });
    });
  }

  function getProductFormState() {
    var properties = window.ForemarkEngrave
      ? window.ForemarkEngrave.getEngraveProperties()
      : {};

    var includeAddon = false;
    var addonCheckbox = document.querySelector('.js-double-sided-checkbox:checked');
    if (!addonCheckbox) {
      addonCheckbox = document.getElementById('double-sided-checkbox');
      if (addonCheckbox && !addonCheckbox.checked) addonCheckbox = null;
    }
    var addonInput = document.getElementById('addon-variant-id');
    if (addonCheckbox && addonInput) {
      includeAddon = true;
    }

    var qtyInput = document.getElementById('qty');
    return {
      properties: properties,
      quantity: parseInt(qtyInput ? qtyInput.value : '1', 10),
      includeAddon: includeAddon,
      addonVariantId: addonInput ? addonInput.value : null
    };
  }

  function handleCartError(err, statusEl) {
    var msg = (err && err.description) ? err.description
      : ((t.product && t.product.error_add) ? t.product.error_add : 'Error adding to cart');
    if (statusEl) {
      statusEl.textContent = msg;
      statusEl.hidden = false;
    }
    return msg;
  }

  // ── 变体选择联动（Product 页）──────────────────────────────────
  var selectedVariantId = theme.selectedVariantId || null;

  function onVariantSelect(variantId, name, price, available) {
    selectedVariantId = variantId;
    theme.selectedVariantId = variantId;

    var priceEl = document.getElementById('product-price');
    if (priceEl && price) {
      priceEl.textContent = formatMoney(price);
    }

    var selectedColor = document.getElementById('selected-color');
    if (selectedColor && name) selectedColor.textContent = name;

    var addBtn = document.getElementById('add-to-cart-btn');
    var buyBtn = document.getElementById('buy-now-btn');
    var soldOut = available === 'false' || available === false;
    var soldOutText = (t.product && t.product.soldOut) ? t.product.soldOut : 'Sold Out';
    var addText = (t.product && t.product.addToCart) ? t.product.addToCart : 'Add to Cart';

    if (addBtn) {
      addBtn.disabled = soldOut;
      addBtn.textContent = soldOut ? soldOutText : addText;
    }
    if (buyBtn) buyBtn.disabled = soldOut;
  }

  window.ForemarkThemeHandlers = { onVariantSelect: onVariantSelect };

  // ── Product 页：数量 + 加购 + Buy Now ───────────────────────────
  function initProductForm() {
    var qtyInput = document.getElementById('qty');
    var qtyMinus = document.getElementById('qty-minus');
    var qtyPlus = document.getElementById('qty-plus');
    var addBtn = document.getElementById('add-to-cart-btn');
    var buyBtn = document.getElementById('buy-now-btn');
    var statusEl = document.getElementById('form-status');

    if (!addBtn && !buyBtn) return;

    var activeSwatch = document.querySelector('.swatch.active');
    if (activeSwatch) {
      onVariantSelect(
        activeSwatch.dataset.variantId,
        activeSwatch.dataset.name,
        activeSwatch.dataset.price,
        activeSwatch.dataset.available
      );
    } else if (theme.variants && theme.variants.length) {
      var first = theme.variants.find(function (v) { return v.available; }) || theme.variants[0];
      selectedVariantId = first.id;
      theme.selectedVariantId = first.id;
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) + 1);
      });
    }

    function runAddToCart(redirectToCheckout) {
      if (!selectedVariantId) return Promise.reject();

      var formState = getProductFormState();
      var buttons = [addBtn, buyBtn].filter(Boolean);
      buttons.forEach(function (btn) { btn.disabled = true; });
      if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }

      return addToCart(selectedVariantId, formState.properties, {
        quantity: formState.quantity,
        includeAddon: formState.includeAddon,
        addonVariantId: formState.addonVariantId
      }).then(function () {
        if (redirectToCheckout) {
          window.location.href = (theme.routes && theme.routes.checkout) || '/checkout';
          return;
        }
        var addedMsg = (t.product && t.product.addedToCart) ? t.product.addedToCart : 'Added to cart';
        var viewCartText = (t.product && t.product.view_cart) ? t.product.view_cart : 'View cart';
        var cartUrl = (theme.routes && theme.routes.cart) || '/cart';
        if (statusEl) {
          statusEl.textContent = addedMsg;
          statusEl.hidden = false;
        }
        showToast(addedMsg, { linkUrl: cartUrl, linkText: viewCartText });
      }).catch(function (err) {
        handleCartError(err, statusEl);
      }).finally(function () {
        buttons.forEach(function (btn) {
          if (!btn) return;
          var soldOut = btn.id === 'add-to-cart-btn' && btn.textContent === ((t.product && t.product.soldOut) || 'Sold Out');
          btn.disabled = !!soldOut;
        });
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        runAddToCart(false);
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        runAddToCart(true);
      });
    }
  }

  // ── 购物车页 ───────────────────────────────────────────────────
  function renderCartProperties(properties) {
    if (!properties) return '';
    var html = '';
    Object.keys(properties).forEach(function (key) {
      if (properties[key]) {
        html += '<div class="foremark-cart-prop"><span>' + key + '</span> ' + properties[key] + '</div>';
      }
    });
    return html;
  }

  function renderCartPage(cart) {
    var emptyEl = document.getElementById('fm-cart-empty');
    var activeEl = document.getElementById('fm-cart-active');
    var itemsEl = document.getElementById('fm-cart-items');
    var subtotalEl = document.getElementById('fm-cart-subtotal');
    var totalEl = document.getElementById('fm-cart-total');
    if (!emptyEl || !activeEl) return;

    updateCartBadge(cart ? cart.item_count : 0);

    if (!cart || cart.item_count === 0) {
      emptyEl.hidden = false;
      activeEl.hidden = true;
      if (itemsEl) itemsEl.innerHTML = '';
      return;
    }

    emptyEl.hidden = true;
    activeEl.hidden = false;
    if (!itemsEl) return;
    itemsEl.innerHTML = '';

    var cartT = t.cart || {};

    cart.items.forEach(function (item) {
      var row = document.createElement('article');
      row.className = 'foremark-cart-item';
      row.dataset.key = item.key;

      var propsHtml = renderCartProperties(item.properties);
      var qtyLabel = cartT.quantity || 'Qty';

      row.innerHTML =
        '<div class="foremark-cart-item-main">' +
          '<h3 class="foremark-cart-item-title">' + item.product_title + '</h3>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="foremark-cart-item-variant">' + item.variant_title + '</p>' : '') +
          (propsHtml ? '<div class="foremark-cart-item-props">' + propsHtml + '</div>' : '') +
        '</div>' +
        '<div class="foremark-cart-item-actions">' +
          '<div class="foremark-cart-qty" aria-label="' + qtyLabel + '">' +
            '<button type="button" class="foremark-cart-qty-btn" data-action="decrease" aria-label="-">−</button>' +
            '<span class="foremark-cart-qty-val">' + item.quantity + '</span>' +
            '<button type="button" class="foremark-cart-qty-btn" data-action="increase" aria-label="+">+</button>' +
          '</div>' +
          '<div class="foremark-cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<button type="button" class="foremark-cart-remove">' + (cartT.remove || 'Remove') + '</button>' +
        '</div>';

      row.querySelector('[data-action="decrease"]').addEventListener('click', function () {
        updateCartItemQuantity(item.key, item.quantity - 1);
      });
      row.querySelector('[data-action="increase"]').addEventListener('click', function () {
        updateCartItemQuantity(item.key, item.quantity + 1);
      });
      row.querySelector('.foremark-cart-remove').addEventListener('click', function () {
        updateCartItemQuantity(item.key, 0);
      });

      itemsEl.appendChild(row);
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function updateCartItemQuantity(key, quantity) {
    changeLineItem(key, Math.max(0, quantity))
      .then(function (cart) {
        renderCartPage(cart);
      })
      .catch(function () {
        fetchCart().then(renderCartPage);
      });
  }

  function bindCartItemEvents(row) {
    if (!row) return;
    var key = row.dataset.key;
    var qtyVal = row.querySelector('.foremark-cart-qty-val');
    var qty = qtyVal ? parseInt(qtyVal.textContent, 10) : 0;
    var dec = row.querySelector('[data-action="decrease"]');
    var inc = row.querySelector('[data-action="increase"]');
    var removeBtn = row.querySelector('.foremark-cart-remove');
    if (dec) {
      dec.addEventListener('click', function () {
        updateCartItemQuantity(key, qty - 1);
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        updateCartItemQuantity(key, qty + 1);
      });
    }
    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        updateCartItemQuantity(key, 0);
      });
    }
  }

  function initCartPage() {
    var root = document.getElementById('foremark-cart');
    if (!root) return;
    root.querySelectorAll('.foremark-cart-item').forEach(bindCartItemEvents);
    fetchCart().then(renderCartPage);
  }

  // ── Contact 表单 ───────────────────────────────────────────────
  function initContactForm() {
    var form = document.getElementById('contact-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var success = document.getElementById('contact-success');
      if (success) success.hidden = false;
      form.hidden = true;
    });
  }

  // ── Clubs 样例表单 ─────────────────────────────────────────────
  function initClubsForm() {
    var form = document.getElementById('clubs-sample-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var success = document.getElementById('clubs-success');
      if (success) success.hidden = false;
      form.hidden = true;
    });
  }

  // ── 移动端导航抽屉 ─────────────────────────────────────────────
  function initMobileNav() {
    var toggle = document.getElementById('fm-menu-toggle');
    var panel = document.getElementById('fm-mobile-nav');
    var backdrop = document.getElementById('fm-mobile-backdrop');
    if (!toggle || !panel) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        panel.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      } else {
        panel.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });
    panel.querySelectorAll('.fm-mobile-nav-link').forEach(function (link) {
      link.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setOpen(false);
    });
  }

  // ── Header 滚动紧凑模式 ───────────────────────────────────────────
  function initHeaderScroll() {
    var siteTop = document.querySelector('.fm-site-top');
    if (!siteTop) return;

    var compactThreshold = 8;
    var ticking = false;

    function update() {
      if (window.scrollY > compactThreshold) {
        siteTop.classList.add('is-compact');
      } else {
        siteTop.classList.remove('is-compact');
      }
      ticking = false;
    }

    update();

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // ── 滚动入场动画 ─────────────────────────────────────────────────
  function initScrollReveal() {
    var sections = document.querySelectorAll('.fm-reveal');
    if (!sections.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    sections.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-visible');
      }
      observer.observe(el);
    });
  }

  function init() {
    initTheme();
    fetchCartCount();
    initProductForm();
    initCartPage();
    initContactForm();
    initClubsForm();
    initMobileNav();
    initHeaderScroll();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ForemarkCart = {
    addToCart: addToCart,
    updateCartBadge: updateCartBadge,
    fetchCart: fetchCart,
    changeLineItem: changeLineItem,
    renderCartPage: renderCartPage
  };
})();
